var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.571289 15.4285H13.1427",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42857 11.4285L4 12.0456L4.57143 8.57132L12.2629 0.902752C12.3691 0.795634 12.4955 0.710612 12.6348 0.652591C12.774 0.59457 12.9234 0.564697 13.0743 0.564697C13.2252 0.564697 13.3745 0.59457 13.5138 0.652591C13.6531 0.710612 13.7795 0.795634 13.8857 0.902752L15.0971 2.11418C15.2043 2.22042 15.2893 2.34683 15.3473 2.48609C15.4053 2.62536 15.4352 2.77474 15.4352 2.92561C15.4352 3.07648 15.4053 3.22586 15.3473 3.36513C15.2893 3.50439 15.2043 3.63079 15.0971 3.73704L7.42857 11.4285Z",
    stroke: "currentColor",
    strokeOpacity: 1,
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDark);
export default __webpack_public_path__ + "static/media/editDark.30b24624e2e2177375d4de1fda990c9e.svg";
export { ForwardRef as ReactComponent };